module.exports = __webpack_public_path__ + "static/media/LowSetupCost.fa9e2eeb.svg";